import { render, staticRenderFns } from "./division_standard_form.vue?vue&type=template&id=5a1b466c&"
import script from "./division_standard_form.vue?vue&type=script&lang=js&"
export * from "./division_standard_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports